module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/annoucments/annoucments.component.css
// module id = ./src/app/home/annoucments/annoucments.component.css
// module chunks = main